import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import { lazyImport } from '@/utils/lazyImport';
import { ROUTE_PATHS } from '@/constants';
import { DocumentDetail, MyAccount } from '@/features/users';

const { UserDashboard } = lazyImport(async () => import('@/features/users'), 'UserDashboard');
const { UserQuotes } = lazyImport(async () => import('@/features/users'), 'UserQuotes');
const { UserShipments } = lazyImport(async () => import('@/features/users'), 'UserShipments');
const { UserSettings } = lazyImport(async () => import('@/features/users'), 'UserSettings');

export const protectedRoutes: RouteObject[] = [
  {
    path: ROUTE_PATHS.user,
    element: <MyAccount />,
    children: [
      { path: ROUTE_PATHS.userDashboard, element: <UserDashboard /> },
      {
        path: ROUTE_PATHS.userQuotes,
        element: <UserQuotes />,
      },
      { path: ROUTE_PATHS.userDocumentDetail, element: <DocumentDetail /> },
      { path: ROUTE_PATHS.usershipments, element: <UserShipments /> },
      { path: ROUTE_PATHS.userSettings, element: <UserSettings /> },
      { path: '*', element: <Navigate to={ROUTE_PATHS.userDashboard} /> },
      {
        index: true,
        element: <Navigate to={ROUTE_PATHS.userDashboard} />,
      },
    ],
  },
];
